import { render } from "./trust_data_fetch.html?vue&type=template&id=dccef1b4&external"
import script from "./trust_data_fetch.js?vue&type=script&lang=js&external"
export * from "./trust_data_fetch.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__